// import { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';

// // antd
// import { DatePicker, Row, Select, Tooltip, theme } from 'antd';
// import { DownloadOutlined } from '@ant-design/icons';

// // slices
// import {
//     clearProjects,
//     projectsList,
//     projectsState,
// } from '../projects/projects.slice';

// // components
// import Button from '../../components/button/button';

// // modal
// import DownloadPopUp from './reportsTimeSheet/downloadPopUp';

// import dayjs from 'dayjs';

// const { RangePicker } = DatePicker;
// const { Option } = Select;

// const pdfDivStyle = {
//     margin: '0px 10px',
// };

// const DateFilter = ({ props }) => {
//     const { dateRangesList, name } = props;

//     const { useToken } = theme;
//     const { token } = useToken();

//     const dispatch = useDispatch();
//     const { skipPage } = useSelector(projectsState);

//     const [pickerVal, setPickerVal] = useState('day');
//     const [changedVal, setChangeVal] = useState(null);
//     const [changedFormat, setChangeFormat] = useState('DD/MM/YYYY');
//     const [dateRanges, setDateRanges] = useState({ start: null, end: null });
//     const [downloadModal, setDownloadModal] = useState(false);

//     // Handle range & picker value changes
//     const handleDateTypeChange = (val) => {
//         setPickerVal(val);

//         if (val === 'day') {
//             setChangeFormat('DD/MM/YYYY');
//             setChangeVal(dayjs());
//         } else if (val === 'week') {
//             setChangeFormat('DD/MM');
//             setChangeVal(dayjs());
//         } else if (val === 'month') {
//             setChangeFormat('MM/YYYY');
//             setChangeVal(dayjs());
//         } else {
//             setChangeVal(null);
//             setDateRanges({ start: null, end: null });
//         }
//     };

//     const handleChangeDate = (val) => {
//         if (!val) {
//             setChangeVal(null);
//             setDateRanges({ start: null, end: null });
//             return;
//         }

//         if (pickerVal === 'custom') {
//             const start = val[0].startOf('day').valueOf();
//             const end = val[1].endOf('day').valueOf();
//             setChangeVal(val);
//             setDateRanges({ start, end });
//             return;
//         }

//         setChangeVal(val);
//         let startDate, endDate;

//         const date = new Date(val);

//         if (pickerVal === 'day') {
//             startDate = date.setHours(0, 0, 0, 0);
//             endDate = date.setHours(23, 59, 59, 999);
//         } else if (pickerVal === 'week') {
//             const weekStart = new Date(date);
//             weekStart.setDate(date.getDate() - date.getDay());
//             weekStart.setHours(0, 0, 0, 0);

//             const weekEnd = new Date(weekStart);
//             weekEnd.setDate(weekEnd.getDate() + 6);
//             weekEnd.setHours(23, 59, 59, 999);

//             startDate = weekStart.getTime();
//             endDate = weekEnd.getTime();
//         } else if (pickerVal === 'month') {
//             const startMonth = new Date(date.getFullYear(), date.getMonth(), 1);
//             const endMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

//             startDate = startMonth.getTime();
//             endDate = new Date(endMonth).setHours(23, 59, 59, 999);
//         }

//         setDateRanges({ start: startDate, end: endDate });
//     };

//     useEffect(() => {
//         // Set initial value on load
//         handleDateTypeChange(pickerVal);
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     useEffect(() => {
//         if (pickerVal && dateRanges?.start && dateRanges?.end) {
//             dispatch(
//                 dateRangesList({
//                     dateRanges,
//                     dateType: pickerVal,
//                 })
//             );
//         }
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [dateRanges]);

//     useEffect(() => {
//         if (localStorage.getItem('authToken') && downloadModal) {
//             dispatch(projectsList({ limit: 30, skip: skipPage }));
//         }
//         return () => dispatch(clearProjects());
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [downloadModal]);

//     return (
//         <>
//             <DownloadPopUp
//                 previewModal={downloadModal}
//                 onComplete={() => { }}
//                 onCancel={() => setDownloadModal(false)}
//                 modalTitle="Download Reports"
//             />

//             <Row
//                 align={'middle'}
//                 style={{
//                     columnGap: '20px',
//                     width: '100%',
//                     flexFlow: 'row nowrap',
//                 }}
//                 justify={'end'}
//             >



//                 {/* Date/Range Picker */}
//                 <div className="reportsDate">
//                     {pickerVal === 'custom' ? (
//                         <RangePicker
//                             value={changedVal}
//                             format="DD/MM/YYYY"
//                             onChange={handleChangeDate}
//                         />
//                     ) : (
//                         <DatePicker
//                             picker={pickerVal}
//                             format={changedFormat}
//                             value={changedVal}
//                             onChange={handleChangeDate}
//                         />
//                     )}
//                 </div>

//                 {/* Picker Type Selector */}
//                 <Select
//                     value={pickerVal}
//                     onChange={handleDateTypeChange}
//                     style={{ width: 120 }}
//                 >
//                     <Option value="day">Day</Option>
//                     <Option value="week">Week</Option>
//                     <Option value="month">Month</Option>
//                     <Option value="custom">Custom</Option>
//                 </Select>

//                 {/* PDF Export */}
//                 {name === 'timeSheet' && (
//                     <div style={pdfDivStyle}>
//                         <Tooltip title="Export as PDF">
//                             <DownloadOutlined
//                                 onClick={() => setDownloadModal(true)}
//                                 style={{ cursor: 'pointer' }}
//                             />
//                         </Tooltip>
//                     </div>
//                 )}
//             </Row>
//         </>
//     );
// };

// export default DateFilter;



import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// antd
import { DatePicker, Row, Select, Tooltip, theme } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

// slices
import {
    clearProjects,
    projectsList,
    projectsState,
} from '../projects/projects.slice';

// components
import Button from '../../components/button/button';

// modal
import DownloadPopUp from './reportsTimeSheet/downloadPopUp';

import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
const { Option } = Select;

const pdfDivStyle = {
    margin: '0px 10px',
};

const DateFilter = ({ props }) => {
    const { dateRangesList, name, selectedProject, selectAssignees } = props;

    const { useToken } = theme;
    const { token } = useToken();

    const dispatch = useDispatch();
    const { skipPage } = useSelector(projectsState);

    const [pickerVal, setPickerVal] = useState("day");
    const [changedVal, setChangeVal] = useState(null);
    const [changedFormat, setChangeFormat] = useState('DD/MM/YYYY');
    const [dateRanges, setDateRanges] = useState({ start: null, end: null });
    const [downloadModal, setDownloadModal] = useState(false);

    // Handle range & picker value changes
    const handleDateTypeChange = (val) => {
        setPickerVal(val);

        const today = dayjs();

        if (val === 'day') {
            setChangeFormat('DD/MM/YYYY');
            setChangeVal(today);

            const startDate = today.startOf('day').valueOf();
            const endDate = today.endOf('day').valueOf();
            setDateRanges({ start: startDate, end: endDate });
        } else if (val === 'week') {
            setChangeFormat('DD/MM');
            setChangeVal(today);

            const start = today.startOf('week').startOf('day').valueOf();
            const end = today.endOf('week').endOf('day').valueOf();
            setDateRanges({ start, end });
        } else if (val === 'month') {
            setChangeFormat('MM/YYYY');
            setChangeVal(today);

            const start = today.startOf('month').startOf('day').valueOf();
            const end = today.endOf('month').endOf('day').valueOf();
            setDateRanges({ start, end });
        } else {
            setChangeVal(null);
            setDateRanges({ start: null, end: null });
        }
    };
    const disableFutureDates = (current) => {
        return current && current > dayjs().endOf('day');
    };

    const handleChangeDate = (val) => {
        if (!val) {
            setChangeVal(null);
            setDateRanges({ start: null, end: null });
            return;
        }

        if (pickerVal === 'custom') {
            const start = val[0].startOf('day').valueOf();
            const end = val[1].endOf('day').valueOf();
            setChangeVal(val);
            setDateRanges({ start, end });
            return;
        }

        setChangeVal(val);
        let startDate, endDate;

        const date = new Date(val);

        if (pickerVal === 'day') {
            startDate = date.setHours(0, 0, 0, 0);
            endDate = date.setHours(23, 59, 59, 999);
        } else if (pickerVal === 'week') {
            const weekStart = new Date(date);
            weekStart.setDate(date.getDate() - date.getDay());
            weekStart.setHours(0, 0, 0, 0);

            const weekEnd = new Date(weekStart);
            weekEnd.setDate(weekEnd.getDate() + 6);
            weekEnd.setHours(23, 59, 59, 999);

            startDate = weekStart.getTime();
            endDate = weekEnd.getTime();
        } else if (pickerVal === 'month') {
            const startMonth = new Date(date.getFullYear(), date.getMonth(), 1);
            const endMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            startDate = startMonth.getTime();
            endDate = new Date(endMonth).setHours(23, 59, 59, 999);
        }

        setDateRanges({ start: startDate, end: endDate });
    };

    useEffect(() => {
        // Set initial value on load
        handleDateTypeChange(pickerVal);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (pickerVal && dateRanges?.start && dateRanges?.end) {
            dispatch(
                dateRangesList({
                    dateRanges,
                    dateType: pickerVal,
                })
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dateRanges]);

    useEffect(() => {
        if (localStorage.getItem('authToken') && downloadModal) {
            dispatch(projectsList({ limit: 30, skip: skipPage }));
        }
        return () => dispatch(clearProjects());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [downloadModal]);

    return (
        <>
            <DownloadPopUp
                previewModal={downloadModal}
                onComplete={() => { }}
                onCancel={() => setDownloadModal(false)}
                modalTitle="Download Reports"
                selectAssignees={selectAssignees}
                selectedProject={selectedProject}
            />

            <Row
                align={'middle'}
                style={{
                    columnGap: '20px',
                    width: '100%',
                    flexFlow: 'row nowrap',
                }}
                justify={'end'}
            >



                {/* Date/Range Picker */}
                <div className="reportsDate">
                    {pickerVal === 'custom' ? (
                        <RangePicker
                            value={changedVal}
                            format="DD/MM/YYYY"
                            onChange={handleChangeDate}
                            disabledDate={disableFutureDates}
                        />
                    ) : (
                        <DatePicker
                            picker={pickerVal}
                            format={changedFormat}
                            value={changedVal}
                            onChange={handleChangeDate}
                            disabledDate={disableFutureDates}
                        />
                    )}
                </div>

                {/* Picker Type Selector */}
                <Select
                    placeholder="Filter"
                    value={pickerVal}
                    onChange={handleDateTypeChange}
                    style={{ width: 120 }}
                >
                    <Option value="day">Day</Option>
                    <Option value="week">Week</Option>
                    <Option value="month">Month</Option>
                    <Option value="custom">Custom</Option>
                </Select>

                {/* PDF Export */}
                {name === 'timeSheet' && (
                    <div style={pdfDivStyle}>
                        <Tooltip title="Export as PDF">
                            <DownloadOutlined
                                onClick={() => setDownloadModal(true)}
                                style={{ cursor: 'pointer' }}
                            />
                        </Tooltip>
                    </div>
                )}
            </Row>
        </>
    );
};

export default DateFilter;
